// All Actions
// Login
export const LOGIN_SAGA = "LOGIN_SAGA";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_CLEAR = "LOGIN_CLEAR";
// Recover password
export const RECOVER_PASWORD_SAGA = "RECOVER_PASWORD_SAGA";
export const RECOVER_PASWORD_SUCCESS = "RECOVER_PASWORD_SUCCESS";
export const RECOVER_PASWORD_FAILURE = "RECOVER_PASWORD_FAILURE";
// Logout
export const LOGOUT_SAGA = "LOGOUT_SAGA";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
// Refresh token
export const REFRESH_TOKEN_SAGA = "REFRESH_TOKEN_SAGA";

// All creators
// Login
export const loginSaga = (email, password) => {
  return {
    type: LOGIN_SAGA,
    payload: { email, password },
  };
};

export const loginSuccess = (name) => {
  return {
    type: LOGIN_SUCCESS,
    payload: { name },
  };
};

export const loginFailure = (errorMessage) => {
  return {
    type: LOGIN_FAILURE,
    payload: { errorMessage },
  };
};

export const loginClear = () => {
  return {
    type: LOGIN_CLEAR
  };
};

// Recover password
export const recoverPasswordSaga = (email) => {
  return {
    type: RECOVER_PASWORD_SAGA,
    payload: { email },
  };
};

export const recoverPasswordSuccess = () => {
  return {
    type: RECOVER_PASWORD_SUCCESS,
  };
};

export const recoverPasswordFailure = (errorMessage) => {
  return {
    type: RECOVER_PASWORD_FAILURE,
    payload: { errorMessage },
  };
};

// Logout
export const logoutSaga = (history = null) => {
  return {
    type: LOGOUT_SAGA,
    payload: { history },
  };
};

export const logoutSuccess = () => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

export const logoutFailure = (errorMessage) => {
  return {
    type: LOGOUT_FAILURE,
    payload: { errorMessage },
  };
};

// Refresh
export const refreshTokenSaga_ = () => {
  return {
    type: REFRESH_TOKEN_SAGA,
  };
};



// WEBPACK FOOTER //
// ./src/stores/Login/Action.js